import { useCallback, useState } from 'react'
import { GenotypingDto } from 'src/dto/genotyping.dto'
import { useGetGenotypingList } from 'src/hooks/api/genotyping'
import { useGenotypingFilteredExport } from 'src/hooks/useGenotypingFilteredExport'

export const useGenotyping = () => {
  const [genotypingItemIsOpen, setGenotypingItemIsOpen] = useState<boolean>(false)
  const [genotypingItem, setGenotypingItem] = useState<GenotypingDto | null>(null)

  const { data: genotypingDataList, isLoading } = useGetGenotypingList()

  const {
    exportData: handleExportData,
    handleFilteredDataChange,
    getExportInfo
  } = useGenotypingFilteredExport(genotypingDataList || [])

  const handleItemDetailModal = useCallback((data?: GenotypingDto) => {
    setGenotypingItem(data || null)
    setGenotypingItemIsOpen((currentModalValue) => !currentModalValue)
  }, [])

  return {
    isLoading,
    genotypingItemIsOpen,
    genotypingItem,
    genotypingDataList,
    setGenotypingItem,
    setGenotypingItemIsOpen,
    handleExportData,
    handleFilteredDataChange,
    getExportInfo,
    handleItemDetailModal
  }
}
